import { SpherePlatformApp } from '@sphere/platform';
import { PATHS } from './marketview.paths';
import { MarketviewWebAppRoute } from './marketview-web-app-route';

export const MarketViewApp: SpherePlatformApp = {
    APP: MarketviewWebAppRoute,
    PATHS
};
